import React from 'react';
import { Helmet } from 'react-helmet';

export function FaqSchemaHeader({ faqSchemaData }) {
	if (!faqSchemaData) {
		return null;
	}

	const schema = `{
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      ${faqSchemaData}
    ]
  }`;

	return (
		<Helmet>
			<script type='application/ld+json'>{schema}</script>
		</Helmet>
	);
}
